import { StartAlarmDto, StartAlarmDtoPersistence } from '../dtos';

export class StartAlarmMapper {
  static toPersistence(data: StartAlarmDto): StartAlarmDtoPersistence {
    return {
      mgroup_id: data.mgroupId,
    };
  }
}
